import { CurrencyConfig } from '../domain/country/type';

export const formatToIndianCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2,
  }).format(amount);
};

// Refer to this for currency codes and number of minor units
// https://dom-content-vault-prod-cdn-assets.porter.in/currency_codes_398bf5db26/currency_codes_398bf5db26.xml
export const formatToCurrency = (
  amount: number,
  currency_config: CurrencyConfig,
): string => {
  return new Intl.NumberFormat(currency_config.currencyLocale, {
    style: 'currency',
    currency: currency_config.currencyCode,
    maximumFractionDigits: currency_config.maxMinorDigits,
    currencyDisplay: 'symbol',
    numberingSystem: 'latn', // forces english numbers instead of local language numbers
  }).format(amount);
};

export function getCurrencyFromString(currency: string): Currency {
  if (currency === inr) {
    return Currency.INR;
  } else {
    throw new Error('unknown currency');
  }
}

export const inr = 'INR';

export enum Currency {
  INR = 'INR',
}

export interface Fare {
  amount: number;
  currency: Currency;
}

const currencySymbolMap: Record<Currency, string> = {
  [Currency.INR]: '₹',
};

export const convertPaiseToRupee = (amount: number): number => amount / 100;

export const formatCurrency = (
  amount_minor: number,
  currency: Currency,
): string => {
  const symbol = currencySymbolMap[currency];

  const wholeAmount =
    currency == Currency.INR
      ? convertPaiseToRupee(amount_minor).toFixed(0)
      : amount_minor;

  const formatted = wholeAmount
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return `${symbol}${formatted}`;
};
